import { SET_SAYTEXT, SET_IPA_FLAVOUR, RESET_FORM,
  FETCHING_DATA } from './Globals'
/*
 * This file contains the action creators.
 */

export const setText = (text) => {
  return { type: SET_SAYTEXT, text }
}

export const setIpaFlavour = (ipaflavour) => {
  return { type: SET_IPA_FLAVOUR, ipaflavour }
}

export const resetForm = () => {
  return { type: RESET_FORM }
}

export const fetchData = (word, ipaflavour) => {
  return {
    type: FETCHING_DATA,
    word,
    ipaflavour
  }
}



// WEBPACK FOOTER //
// ./src/Actions.js